module.exports = __webpack_public_path__ + "static/media/pro-audio-banner.312651fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProAudioPage/assets/pro-audio-banner.png
// module id = 532
// module chunks = 0